import './modalContent.css'

export default function FascinationFactory() {
  return (
    <div className='modal-content'>
      <h2 className='modal-header'>Fascination Factory: A Window into My Hobbies and Interests</h2>
      <div className='modal-body'>
        <p>
          Welcome to the Fascination Factory! This is where my hobbies and personal interests come to life. It’s a
          colorful tapestry of activities that fuel my creativity and keep me balanced. Let's take a stroll through this
          factory and explore the diverse interests that inspire me every day.
        </p>
        <h3>🖨️ 3D Printing: Crafting the Future</h3>
        <p>
          My journey with 3D printing is all about bringing imagination to reality. From intricate models to functional
          gadgets, each print is a step into a world where the only limit is creativity itself.
        </p>
        <h3>🍳 Cooking: A Global Culinary Adventure</h3>
        <p>
          Cooking is my passport to the flavors of the world. I love exploring and learning new recipes from different
          cultures. Each dish is a new adventure, a story told through spices and ingredients.
        </p>
        <h3>🎵 Making Music: Harmonizing Life</h3>
        <p>
          Music is my soul's voice. Whether it's strumming the guitar or tapping the rhythm on the drums, making music
          is my way of expressing emotions and capturing moments.
        </p>
        <h3>🖌️ 3D Modeling: Bringing Ideas to Life</h3>
        <p>
          3D modeling is not just a hobby; it's a form of art and expression. Everything you see on this site, from the
          interactive elements to the detailed landscapes, was designed and modeled by me. It's a blend of technical
          skill and creative vision, bringing ideas from the mind into the digital world.
        </p>
        <hr
          style={{
            color: 'white',
            width: '25%',
            marginTop: '25px',
            marginBottom: '25px',
          }}
        />
        <p>
          The Fascination Factory is more than just a showcase of hobbies; it's a reflection of my passions and the joys
          I find in life. It's about living life to the fullest and embracing the vast array of experiences it has to
          offer. Thanks for visiting, and I hope you find your own fascinations to explore!
        </p>
      </div>
    </div>
  )
}
